import Swiper from 'swiper'

const Anchors = () => {
    const swiper = new Swiper('.anchors-slider', {
        allowTouchMove: true,
        slidesPerView: 'auto',
        grabCursor: true,
       
    })
    const anchors = document.querySelectorAll('.anchor-item');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();
            
            const targetId = this.getAttribute('href');
            const targetIdNoHash = targetId.replace(/^#/, '');

            const targetElement = document.getElementById(targetIdNoHash);
            
            if (targetElement) {
                const offset = 168; 
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}


export default Anchors
